import { useEffect, useState } from 'react'
import { ArrowRight } from 'blaze-ui/icons'
import Styles from './SelectedImagesPreview.module.scss'
import cx from 'classnames'
import { Image } from 'components/UserProfileCard/Image'
import { Button } from 'blaze-ui/Button'
import { IMediaFile } from 'components/Design/UploadsTab/Types'
import { Pressable } from '@react-aria/interactions'
import { observer } from 'mobx-react-lite'
import { IObservableArray } from 'mobx'

interface SelectedImagesPreviewProps {
  onReviewImages: () => void
  selectedFiles: IObservableArray<IMediaFile>
  onClear: () => void
  onSubmit: () => void
  submitLabel?: string
}

export const SelectedImagesPreview = observer((props: SelectedImagesPreviewProps) => {
  const { onReviewImages, onClear, onSubmit, selectedFiles, submitLabel = 'Generate Post' } = props
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    if (selectedFiles.length > 0) {
      setIsVisible(true)
    } else {
      setIsVisible(false)
    }
  }, [selectedFiles.length])

  if (selectedFiles.length === 0) {
    return null
  }

  return (
    <>
      <div className={cx(Styles.overlay, { [Styles.visible]: isVisible })} />
      <div className={cx(Styles.container, { [Styles.visible]: isVisible })} data-testid="selected-images-preview">
        <div className={Styles.header}>
          <div className={Styles.title}>Review images ({selectedFiles.length})</div>
          <button className={Styles.clearButton} onClick={onClear}>
            Clear
          </button>
        </div>
        <div className={Styles.imagesGrid}>
          {selectedFiles.map((file) => (
            <Pressable key={file.id} onPress={onReviewImages}>
              <div className={Styles.imageContainer} role="button" tabIndex={0}>
                <Image src={file.source_url} alt={file.title || 'Selected image'} className={Styles.image} />
              </div>
            </Pressable>
          ))}
        </div>

        <Button variant="primary" size="lg" onPress={onSubmit} endIcon={ArrowRight} fullWidth>
          {submitLabel}
        </Button>
      </div>
    </>
  )
})
